import dayjs from "dayjs";
import { EmployeeReport, ChildrenReport, RelativeReport, File, FileDetail } from "types";
import { formatDate } from "lib/helpers/formatDate";

export const employeeGridMapper = (employees: EmployeeReport[]) => {
  return employees?.map((employee: EmployeeReport) => {
    return {
      ...employee,
      id: employee.surveyId,
      surveyDate: employee?.surveyDate ? dayjs(employee.surveyDate).format("YYYY-MM-DD") : "",
      birthDate: employee?.birthDate ? dayjs(employee.birthDate).format("YYYY-MM-DD") : "",
      birthdateSpouse: employee?.birthdateSpouse ? dayjs(employee.birthdateSpouse)?.format("YYYY-MM-DD") : "",
    };
  });
};

export const childrenGridMapper = (children: ChildrenReport[]): ChildrenReport[] =>
  children?.map((child: ChildrenReport) => ({
    ...child,
    id: child.surveyId,
    surveyDate: dayjs(child.surveyDate).format("YYYY-MM-DD"),
    birthDate: dayjs(child.birthDate).format("YYYY-MM-DD"),
  })) ?? [];

export const relativesGridMapper = (relatives: RelativeReport[]): RelativeReport[] =>
  relatives?.map((relative: RelativeReport) => ({
    ...relative,
    id: relative.surveyId,
    surveyDate: relative?.surveyDate ? dayjs(relative.surveyDate).format("YYYY-MM-DD") : "",
    birthDate: relative?.birthDate ? dayjs(relative.birthDate).format("YYYY-MM-DD") : "",
  })) ?? [];

export const historyFileGridMapper = (files: File[]): File[] =>
  files?.map((file: File, index) => ({
    ...file,
    id: index,
    creationDate: dayjs(file.creationDate).format("YYYY-MM-DD"),
  })) ?? [];

export const fileDetailGridMapper = (fileDetails: FileDetail[]): FileDetail[] =>
  fileDetails?.map((fileDetail: FileDetail) => ({
    ...fileDetail,
    id: fileDetail?.numeroDocumento,
    fechaInicio: formatDate(fileDetail?.fechaInicio),
    fechaFin: formatDate(fileDetail?.fechaFin),
    creationDate: fileDetail?.creationDate ? dayjs(fileDetail.creationDate).format("YYYY-MM-DD") : "",
  })) ?? [];
